import { useCustomSelector } from '@/core/redux/hooks';

interface Props {
	width?: string;
}

export const Network = ({ width = 'auto' }: Props) => {
	/*********************
	// #region Redux
	**********************/
	const { networkSelected } = useCustomSelector((state) => state.network);

	return (
		<img src={networkSelected.image} width={width} className="h-[25px]" />
	);
};
